import { WS_URL } from "../constants/ws-constants";

const getSocketUrl = (defaultSocketUrl: string, serverAddress: string, port: string): string => {
    const url = window.location.href;
    const { hostname } = new URL(url);

    // if (hostname === "localhost") {
    //     return defaultSocketUrl.replace("localhost", `${serverAddress}:${port}`);
    // } // Commenting out localhost check to allow testing with local ICA and remote plugins server
    
    return defaultSocketUrl.replace("localhost", `${hostname}:${port}`);
}

export const getSecureWebsocketIca = (serverAddress: string, securePort: string): string => {
    return getSocketUrl(WS_URL.SECURED_ICA_WEBSOCKET, serverAddress, securePort);
}

export const getUnsecureWebsocketIca = (serverAddress: string, unsecurePort: string): string => {
    return getSocketUrl(WS_URL.UNSECURED_ICA_WEBSOCKET, serverAddress, unsecurePort);
}

export const getSecureWebsocketPlugins = (serverAddress: string, securePort: string): string => {
    return getSocketUrl(WS_URL.SECURED_PLUGIN_MANAGER_WEBSOCKET, serverAddress, securePort);
}

export const getUnsecureWebsocketPlugins = (serverAddress: string, unsecurePort: string): string => {
    return getSocketUrl(WS_URL.UNSECURED_PLUGIN_MANAGER_WEBSOCKET, serverAddress, unsecurePort);
}
